<md-dialog  aria-label="{{'SHARED_DOCUMENT_PASTE_OVERWRITE_TITLE' | translate}}">
  <form>
    <md-toolbar>
      <div class="md-toolbar-tools">
        <h2>{{'SHARED_DOCUMENT_PASTE_OVERWRITE_TITLE' | translate}}</h2>
        <span flex></span>
        <md-button class="md-icon-button" ng-click="hide()" ng-disabled="!$root.permisos.ACTUALITZARENT.edit">
          <md-icon aria-label="{{'DEFAULT_TANCAR' | translate}}">close</md-icon>
        </md-button>
      </div>
    </md-toolbar>
    <md-dialog-content>
      <div class="md-dialog-content">
        <p>{{'SHARED_DOCUMENT_PASTE_OVERWRITE_CONTENT' | translate}}</p>
      </div>
    </md-dialog-content>
    <md-dialog-actions layout="row">
      <md-button class="md-primary md-button md-default-theme md-ink-ripple" ng-click="hide()">
       {{'DEFAULT_CANCELAR' | translate}}
      </md-button>
      <md-button class="md-primary md-button md-default-theme md-ink-ripple" ng-click="accept()" ng-if="$root.permisos.DOCUMENT.edit">
        {{'DEFAULT_SOBREESCRIURE' | translate}}
      </md-button>
    </md-dialog-actions>
  </form>
</md-dialog>
